import React from 'react';
import { SyncLoader } from 'react-spinners';

import './styles.scss';

interface ViewLoaderProps {
  color?: string;
}

const ViewLoader = ({ color = '#2a2a2a' }: ViewLoaderProps) => (
  <div className="spinner-wrapper">
    <SyncLoader color={color} />
  </div>
);

export default ViewLoader;
